export default __webpack_public_path__ + "static/media/prooctane-utility-can.5f28f0a2.jpg";